import { Spinner } from "react-bootstrap"

const PageLoadingIndicator = () => (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
        <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
        </Spinner>
    </div>
);

export default PageLoadingIndicator;
